import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { clearAdminToken } from "@/lib/api";

export function AdminShell({ children }) {
  const navigate = useNavigate();
  const logout = () => {
    clearAdminToken();
    navigate("/admin/login", { replace: true });
  };
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 flex items-center justify-between border-b border-border bg-primary px-4 py-3 text-primary-foreground sm:px-6">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-6 w-6" />
          <span className="text-base font-extrabold tracking-tight">CargoFlow Admin</span>
        </div>
        <button
          data-testid="admin-logout"
          onClick={logout}
          className="flex items-center gap-2 rounded-xl bg-white/15 px-3 py-2 text-sm font-bold text-primary-foreground hover:bg-white/25"
        >
          <LogOut className="h-4 w-4" /> Esci
        </button>
      </header>
      <main className="mx-auto w-full max-w-5xl px-4 py-6 sm:px-6">{children}</main>
    </div>
  );
}
